import React from 'react';
import { Link } from 'react-router-dom';
export function TermsAndConditions() {
  const infoPages = [{
    name: 'FAQs',
    path: '/12.html'
  }, {
    name: 'Compliance',
    path: '/Compliance'
  }, {
    name: 'Screen Printing Advice',
    path: '/Screen-Printing-Advice'
  }, {
    name: 'What is Vector Art?',
    path: '/What-is-Vector-Art'
  }, {
    name: 'The Wear Haus Way',
    path: '/The-Wear-Haus-Way'
  }, {
    name: 'Terms and Conditions',
    path: '/Terms'
  }, {
    name: 'Privacy Policy',
    path: '/Privacy'
  }];
  return <div className="flex flex-col w-full" data-id="element-728">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-yellow to-yellow-500 py-16" data-id="element-729">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-730">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-731">
            Terms and Conditions
          </h1>
          <p className="text-xl text-gray-800" data-id="element-732">
            Also known as "the fine print."
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50" data-id="element-733">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-734">
          <div className="flex flex-col lg:flex-row gap-8" data-id="element-735">
            {/* Sidebar Navigation */}
            <aside className="lg:w-64 flex-shrink-0" data-id="element-736">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sticky top-24" data-id="element-737">
                <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-738">
                  Helpful Info
                </h3>
                <nav className="space-y-2" data-id="element-739">
                  {infoPages.map(page => <Link key={page.path} to={page.path} className={`block px-3 py-2 rounded-md text-sm font-medium transition-colors ${page.path === '/Terms' ? 'bg-wh-pink text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-740">
                      {page.name}
                    </Link>)}
                </nav>
              </div>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1" data-id="element-741">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-742">
                <div className="prose prose-lg max-w-none text-gray-700" data-id="element-743">
                  <div className="mb-10" data-id="element-744">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-745">
                      Pre-Production Samples/Sew-Outs
                    </h3>
                    <p data-id="element-746">
                      Pre-production samples are the only way to ensure imprint
                      accuracy. Wear Haus Designs will not be held responsible
                      for slight shifts in color without a pre-production
                      sample/sew-out. We will run one sample for your records.
                      Pre-production samples will be billed within 30 days of
                      printing regardless of order status.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-747">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-748">
                      Photo Proofs
                    </h3>
                    <p data-id="element-749">
                      Photo proofs can be emailed, free of charge, on orders
                      over 1,000 pieces. If the customer responds with changes,
                      depending on the change, the job may be rescheduled and
                      billed as a pre-production sample.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-750">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-751">
                      Virtual Proofs
                    </h3>
                    <p data-id="element-752">
                      Virtual proofs are created and emailed to the customer at
                      the order entry stage of the process to ensure accuracy of
                      art and placement. It is up to the customer to review
                      these proofs with great attention to detail to guarantee
                      they are correct before approving, therefore Wear Haus
                      Designs is not responsible for errors in approved designs.
                      We must receive your approval before the order can proceed
                      to production.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-753">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-754">
                      Customer Separations
                    </h3>
                    <p data-id="element-755">
                      Process separations supplied by the customer will not be
                      accepted. Our separations are created specifically for our
                      factory depending on the decoration method. We have a
                      talented team of graphic designers who are happy to help
                      make your vision a reality. Contact us for more
                      information.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-756">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-757">
                      Art Revision Fees
                    </h3>
                    <p data-id="element-758">
                      Each order includes 30 minutes of art time to prep the
                      file for printing at no charge. The first customer
                      revision is free, however any revision requests after the
                      first free revision will incur a $45/hr fee, per project.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-759">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-760">
                      Printing on Youth and Adult Garments
                    </h3>
                    <p data-id="element-761">
                      If different size screens are needed for printing the same
                      design on youth and adult garments then print charges will
                      be based on separate runs. However, an imprint size can
                      sometimes be determined to accommodate all sizes, so
                      please call for advice.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-762">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-763">
                      Cancellation
                    </h3>
                    <p data-id="element-764">
                      Order cancellations may be confirmed in writing up to
                      three days after the order is placed. A restocking fee of
                      20% of the total order cost may apply. Cancellations will
                      not be accepted for orders that have already been
                      produced. For non-profit cancellations, any associated
                      costs leading up to the production of your order will be
                      invoiced accordingly.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-765">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-766">
                      Unique Locations
                    </h3>
                    <p data-id="element-767">
                      Printing over seams, zippers, collars, or other unique
                      locations may lead to ink build ups, registration issues,
                      and coverage and consistency issues. Unique locations are
                      subject to garment style and sizes for each individual
                      order. In some cases we may be restricted, so the art will
                      be sized based on the smallest garment (or a certain style
                      if you are using more than one style in your order).
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-768">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-769">
                      Printing Tolerance
                    </h3>
                    <p data-id="element-770">
                      We allow up to a ½ inch movement tolerance in any
                      direction per imprint.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-771">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-772">
                      Neck Tag Printing
                    </h3>
                    <p data-id="element-773">
                      Neck Tag Printing on the inside of the shirt will
                      typically show through to the other side. This is
                      especially noticeable when there is high contrast between
                      shirt color and ink color (black ink on a white shirt, for
                      example). To minimize this issue please request a neck tag
                      print color that has enough contrast to the garment but
                      isn't so dark/light that it might easily show through the
                      garment. We're happy to help you choose ink colors based
                      on your project.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-774">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-775">
                      Production Time
                    </h3>
                    <p data-id="element-776">
                      Production time begins once a complete purchase order,
                      acceptable art file, and garments are received. The
                      standard turnaround is two weeks. If you need your
                      garments before the standard production time, a rush fee
                      may apply.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-777">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-778">
                      Garment Reaction to Heat
                    </h3>
                    <p data-id="element-779">
                      Tags, garments, and decorations may shrink slightly when
                      exposed to heat during the ink curing process. This is a
                      risk inherent in the nature of the materials when exposed
                      to heat, and something that we cannot control. If you're
                      not sure about your chosen garments we can help you choose
                      an appropriate garment for your project.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-780">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-781">
                      4 Color Process Printing
                    </h3>
                    <p data-id="element-782">
                      This process uses CMYK printing. By using detailed
                      halftones and laying them over each other, we are able to
                      print a full gamut of colors. Although very precise, many
                      times the exact Pantone® match is not possible. If there
                      is a need for an exact color match a spot color will be
                      added into the pricing and production run. We will add a
                      maximum of two additional spot colors for each process
                      print.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-783">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-784">
                      Discharge Limitations
                    </h3>
                    <p data-id="element-785">
                      Discharge inks will only work on 100% cotton material. An
                      exact PMS match is not possible and the imprint color will
                      vary based on the color shirt and dye lot.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-786">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-787">
                      Dye Migration Warning
                    </h3>
                    <p data-id="element-788">
                      Polyester and nylon dye migration happens when the dye in
                      the fabric of the garment is sublimated and turns into a
                      colored gas. It will then try to escape the garment and
                      can get stuck in the ink applied to the garment. It will
                      slowly permeate through and can discolor the ink slightly
                      or completely, depending on the garment and the print
                      process. Darker colored garments are more likely to
                      migrate (red, blue, black, etc). Dye migration may appear
                      hours or weeks after the ink is cured. Wear Haus Designs
                      uses polyester inks and nylon additives to attempt to
                      lower the chance of dye migration, however we cannot
                      completely control this issue. The customer must accept
                      the risk of dye migration when printing polyester,
                      polyester blends, and nylon goods.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-789">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-790">
                      Foil Longevity
                    </h3>
                    <p data-id="element-791">
                      Foil is a topical heat-pressed effect that is adhered
                      after the garment has been decorated with either standard
                      plastisol inks or special foil adhesives. Foil is not a
                      permanent decoration as rough abrasion or harsh washing
                      will cause foil to flake and come off of garments. For
                      best results, wash garments inside out, on a delicate
                      cycle, in cold water only. Foil can last 1-5 washes
                      depending on care of garment. We offer a basic palette of
                      foil colors, and specialty colors can be ordered.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-792">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-793">
                      Unclaimed Garments
                    </h3>
                    <p data-id="element-794">
                      Garments that are in our possession for more than 90 days
                      become the property of Wear Haus Designs. It is the
                      customer's responsibility to claim any garments before
                      this deadline. Misprinted and damaged garments become our
                      property after 30 days.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-795">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-796">
                      Dispute of Quality
                    </h3>
                    <p data-id="element-797">
                      We will replace any garments not produced at our standard
                      of quality. This does not apply to garments supplied by
                      the customer. Claims must be made within 10 days of
                      receipt of merchandise. Please contact us for more
                      information.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-798">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-799">
                      Shipping Charges
                    </h3>
                    <p data-id="element-800">
                      Shipping charges are calculated based on the actual
                      weight, distance traveled, declared value, and type of
                      shipping service you specify (ground, next day, second
                      day, etc). We cannot be held to the shipping charges
                      estimated. Complete packing and shipping instructions must
                      be finalized 48 hours in advance of your ship date to
                      ensure prompt delivery of your order.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-801">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-802">
                      Handling Fees
                    </h3>
                    <p data-id="element-803">
                      Each order will incur a $3 handling fee per package
                      shipped.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-804">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-805">
                      Shipping Insurance
                    </h3>
                    <p data-id="element-806">
                      Orders will be insured upon request. The customer is
                      responsible for all shipping charges unless prior
                      arrangements are made.
                    </p>
                  </div>

                  <div className="mb-10" data-id="element-807">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-808">
                      Blind Shipping
                    </h3>
                    <p data-id="element-809">
                      Blind shipping is available upon request at no additional
                      charge
                    </p>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </section>
    </div>;
}